import { useEffect } from 'react';

const BASE_TITLE = 'Netfiscus';

/**
 * Sets the document title with the app name suffix.
 * @param title - Page-specific title, or null/undefined to show base title only
 * @example usePageTitle('Dashboard') // "Dashboard | Netfiscus"
 * @example usePageTitle(ledger?.name) // "My Savings | Netfiscus" when loaded
 */
export function usePageTitle(title?: string | null) {
    useEffect(() => {
        document.title = title ? `${title} | ${BASE_TITLE}` : BASE_TITLE;

        return () => {
            document.title = BASE_TITLE;
        };
    }, [title]);
}
